import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IndicativeLoanOffer } from '../../../model/cibil/indicative-loan.model';
import { Keys, StorageService } from '../../../service/storage.service';

@Component({
  selector: 'app-indicative-loan',
  templateUrl: './indicative-loan.component.html',
  styleUrls: ['./indicative-loan.component.css']
})
export class IndicativeLoanComponent implements OnInit {
  @Input() indicativeLoan: IndicativeLoanOffer;
  @Output() isApplyNowClicked = new EventEmitter<boolean>();;
  public preApprovedLoanOfferCard: PreApprovedLoanOfferCard;

  constructor(
    private readonly storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.setPreApprovedLoanOfferCard('pre-approved-loan-offer.svg', 'Congratulations!', 'You have a pre- approved');
  }

  private setPreApprovedLoanOfferCard(image: string, header: string, description: string): void {
    this.preApprovedLoanOfferCard = {
      image: image,
      header: header,
      description: description
    };
  }

  navigateToLoanInfo() {
    this.removeLoanApplicationFromLocalStorage();
    this.isApplyNowClicked.emit(true);
  }

  removeLoanApplicationFromLocalStorage() {
    this.storageService.removeItem(Keys.LOAN_APPLICATION);
  }
}

export interface PreApprovedLoanOfferCard {
  image: string;
  header: string;
  description: string;
}